import { Report, SeriesComponentsDates, SeriesData, SeriesDetails } from '../../types/Series';

export const SET_IS_LOADING = '@SERIES/SET_IS_LOADING';
export const GET_SERIES = '@SERIES/GET_SERIES';
export const SET_SERIES = '@SERIES/SET_SERIES';
export const GET_SERIES_DETAILS = '@SERIES/GET_SERIES_DETAILS';
export const SET_SERIES_DETAILS = '@SERIES/SET_SERIES_DETAILS';
export const SET_ERROR = '@SERIES/SET_ERROR';
export const SET_SERIES_SUBMISSION_REPORTS = '@SERIES/SET_SERIES_SUBMISSION_REPORTS';
export const SET_SERIES_TRAINING_REPORTS = '@SERIES/SET_SERIES_TRAINING_REPORTS';
export const ADD_REPORT_AS_BEING_GENERATED = '@SERIES/ADD_REPORT_AS_BEING_GENERATED';
export const REMOVE_REPORT_AS_BEING_GENERATED = '@SERIES/REMOVE_REPORT_AS_BEING_GENERATED';
export const RESET_REPORTS_GENERATED_LIST = '@SERIES/RESET_REPORTS_GENERATED_LIST';
export const SET_ACTIVE_SERIES_IDS = '@SERIES/SET_ACTIVE_SERIES_IDS';
export const SET_FUTURE_SERIES_IDS = '@SERIES/SET_FUTURE_SERIES_IDS';
export const SET_SUBMISSION_REPORT_REQUEST_IS_LOADING = '@SERIES/SET_SUBMISSION_REPORT_REQUEST_IS_LOADING';
export const SET_SUBMISSION_REPORT_HAS_LOADED = '@SERIES/SET_SUBMISSION_REPORT_HAS_LOADED';
export const SET_SUBMISSION_REPORT_INDEX = '@SERIES/SET_SUBMISSION_REPORT_INDEX';
export const SET_SERIES_COMPONENTS_DATES = '@SERIES/SET_SERIES_COMPONENTS_DATES';

export interface SetIsLoading {
  type: typeof SET_IS_LOADING;
  payload: { value: boolean };
}

export interface SetSeriesComponentsDates {
  type: typeof SET_SERIES_COMPONENTS_DATES;
  payload: { seriesComponents: SeriesComponentsDates };
}

export interface GetSeries {
  type: typeof GET_SERIES;
}

export interface SetSeries {
  type: typeof SET_SERIES;

  payload: {
    seriesData: SeriesData;
  };
}

export interface GetSeriesDetails {
  type: typeof GET_SERIES_DETAILS;
}

export interface SetSeriesDetails {
  type: typeof SET_SERIES_DETAILS;

  payload: {
    seriesDetails: SeriesDetails | undefined;
  };
}

export interface SetSeriesSubmissionReports {
  type: typeof SET_SERIES_SUBMISSION_REPORTS;

  payload: {
    submissionReports: Report[];
  };
}

export interface SetSeriesTrainingReports {
  type: typeof SET_SERIES_TRAINING_REPORTS;

  payload: {
    trainingReports: Report[];
  };
}

export interface AddReportAsBeingGenerated {
  type: typeof ADD_REPORT_AS_BEING_GENERATED;

  payload: {
    index: number;
  };
}

export interface RemoveReportAsBeingGenerated {
  type: typeof REMOVE_REPORT_AS_BEING_GENERATED;

  payload: {
    index: number;
  };
}

export interface ResetReportsGeneratedList {
  type: typeof RESET_REPORTS_GENERATED_LIST;
}

export interface SetError {
  type: typeof SET_ERROR;
}

export interface SetActiveSeriesIds {
  type: typeof SET_ACTIVE_SERIES_IDS;
  payload: {
    ids: number[];
  };
}

export interface SetFutureSeriesIds {
  type: typeof SET_FUTURE_SERIES_IDS;
  payload: {
    ids: number[];
  };
}

export interface SetSubmissionReportIsLoading {
  type: typeof SET_SUBMISSION_REPORT_REQUEST_IS_LOADING;
  payload: {
    isLoading: boolean;
  };
}

export interface SetSubmissionReportIndex {
  type: typeof SET_SUBMISSION_REPORT_INDEX;
  payload: {
    index?: number;
  };
}

export interface SetSubmissionReportHasLoaded {
  type: typeof SET_SUBMISSION_REPORT_HAS_LOADED;
  payload: {
    hasLoaded: boolean;
  };
}

export type SeriesActionTypes =
  | GetSeries
  | SetSeries
  | GetSeriesDetails
  | SetSeriesDetails
  | SetSeriesSubmissionReports
  | SetSeriesTrainingReports
  | AddReportAsBeingGenerated
  | RemoveReportAsBeingGenerated
  | ResetReportsGeneratedList
  | SetError
  | SetActiveSeriesIds
  | SetFutureSeriesIds
  | SetIsLoading
  | SetSubmissionReportIsLoading
  | SetSubmissionReportIndex
  | SetSubmissionReportHasLoaded
  | SetSeriesComponentsDates;
